import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=a6df1776&"
import script from "./Chat.vue?vue&type=script&lang=js&"
export * from "./Chat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6df1776')) {
      api.createRecord('a6df1776', component.options)
    } else {
      api.reload('a6df1776', component.options)
    }
    module.hot.accept("./Chat.vue?vue&type=template&id=a6df1776&", function () {
      api.rerender('a6df1776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/Chat.vue"
export default component.exports